/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { useDispatch, useSelector } from 'store'
import { useHistory } from 'react-router'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { clickF } from 'types/FunctionTypes'
import { format } from 'slicers/LoginSlice'
import M_ButtonNormal from 'components/1_Atoms/2_Molecules/M_ButtonNormal'

const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#000000',
      backgroundColor: manualMode || process.env.REACT_APP_ENVIRONMENT === 'prod' ? '#66FF99' : '#FF99FF',
    },
    menuButton: {
      marginRight: theme.spacing(1),
    },
    title: {
      // flexGrow: 1,
      cursor: 'pointer',
    },
    flex: {
      flexGrow: 1,
    },
  }),
)

type Props = {
  sysName: string
  handleOpenMenu: clickF
}

const O_HeaderMobile = ({ sysName, handleOpenMenu }: Props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.PageReducer.loading)
  // const NAME = useSelector((state) => state.LoginReducer.NAME)
  const history = useHistory()
  // const location = useLocation()

  const logout = () => {
    dispatch(format())
    history.push('/') // ログイン画面に遷移
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar variant="dense">
        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleOpenMenu}>
          <MenuIcon />
        </IconButton>
        <Typography className={classes.title} onClick={handleOpenMenu} variant="subtitle1" noWrap>
          {sysName}
        </Typography>
        <Typography className={classes.flex} variant="caption" noWrap></Typography>
        <M_ButtonNormal label={'ログアウト'} event={logout} />
      </Toolbar>
      {loading ? <LinearProgress /> : ''}
    </AppBar>
  )
}
export default React.memo(O_HeaderMobile)
